export interface LifePathMeaning {
    number: number;
    title: string;
    keywords: string[];
    description: string;
    strengths: string[];
    challenges: string[];
}

export const lifePathMeanings: Record<number, LifePathMeaning> = {
    1: {
        number: 1,
        title: "The Leader",
        keywords: ["Independence", "Ambition", "Innovation", "Leadership"],
        description: "Life Path 1s are born leaders. You are independent, ambitious, and driven to succeed. You have a pioneering spirit and are not afraid to take risks to achieve your goals.",
        strengths: ["Self-motivated", "Courageous", "Creative", "Decisive"],
        challenges: ["Impatience", "Arrogance", "Stubbornness", "Self-centeredness"]
    },
    2: {
        number: 2,
        title: "The Peacemaker",
        keywords: ["Harmony", "Cooperation", "Diplomacy", "Sensitivity"],
        description: "Life Path 2s are the diplomats of the numerology world. You are sensitive, intuitive, and strive for harmony in all your relationships. You are a natural mediator.",
        strengths: ["Empathetic", "Patient", "Supportive", "Intuitive"],
        challenges: ["Oversensitive", "Indecisive", "Self-sacrificing", "Fear of conflict"]
    },
    3: {
        number: 3,
        title: "The Creative",
        keywords: ["Expression", "Creativity", "Optimism", "Social"],
        description: "Life Path 3s are the communicators and artists. You are creative, expressive, and have a zest for life. You love to connect with others and bring joy to the world.",
        strengths: ["Charismatic", "Artistic", "Optimistic", "Witty"],
        challenges: ["Scattered", "Superficial", "Moody", "Exaggeration"]
    },
    4: {
        number: 4,
        title: "The Builder",
        keywords: ["Stability", "Organization", "Discipline", "Hard Work"],
        description: "Life Path 4s are the builders and organizers. You are practical, grounded, and value stability. You are willing to put in the hard work to build a solid foundation for the future.",
        strengths: ["Reliable", "Disciplined", "Practical", "Loyal"],
        challenges: ["Rigid", "Stubborn", "Workaholic", "Judgmental"]
    },
    5: {
        number: 5,
        title: "The Adventurer",
        keywords: ["Freedom", "Change", "Adventure", "Versatility"],
        description: "Life Path 5s are the free spirits. You crave adventure, variety, and freedom. You are adaptable and love to explore new places, ideas, and experiences.",
        strengths: ["Adaptable", "Energetic", "Curious", "Charismatic"],
        challenges: ["Restless", "Impulsive", "Inconsistent", "Irresponsible"]
    },
    6: {
        number: 6,
        title: "The Nurturer",
        keywords: ["Responsibility", "Care", "Family", "Service"],
        description: "Life Path 6s are the nurturers and caregivers. You have a deep sense of responsibility towards your family and community. You strive to create a loving and harmonious environment.",
        strengths: ["Compassionate", "Responsible", "Protective", "Loving"],
        challenges: ["Controlling", "Self-righteous", "Meddling", "Martyr complex"]
    },
    7: {
        number: 7,
        title: "The Seeker",
        keywords: ["Wisdom", "Introspection", "Analysis", "Spirituality"],
        description: "Life Path 7s are the seekers of truth. You are analytical, introspective, and have a deep desire to understand the mysteries of life. You value solitude and intellectual pursuits.",
        strengths: ["Analytical", "Intuitive", "Intellectual", "Spiritual"],
        challenges: ["Reclusive", "Cynical", "Suspicious", "Overthinking"]
    },
    8: {
        number: 8,
        title: "The Powerhouse",
        keywords: ["Success", "Authority", "Abundance", "Management"],
        description: "Life Path 8s are the powerhouses of the numerology world. You are ambitious, goal-oriented, and have a natural talent for business and leadership. You strive for material and financial success.",
        strengths: ["Ambitious", "Organized", "Confident", "Practical"],
        challenges: ["Materialistic", "Domineering", "Workaholic", "Entitled"]
    },
    9: {
        number: 9,
        title: "The Humanitarian",
        keywords: ["Compassion", "Generosity", "Idealism", "Global Consciousness"],
        description: "Life Path 9s are the humanitarians. You are compassionate, generous, and have a desire to make the world a better place. You are often drawn to social causes and helping others.",
        strengths: ["Compassionate", "Generous", "Idealistic", "Creative"],
        challenges: ["Resentful", "Moody", "Unrealistic", "Self-sacrificing"]
    },
    11: {
        number: 11,
        title: "The Master Intuitive",
        keywords: ["Intuition", "Inspiration", "Illumination", "Spirituality"],
        description: "Life Path 11 is a Master Number. You possess heightened intuition and spiritual insight. You are here to inspire and illuminate others with your vision.",
        strengths: ["Intuitive", "Inspirational", "Visionary", "Spiritual"],
        challenges: ["Anxious", "Overwhelmed", "Impractical", "Hypersensitive"]
    },
    22: {
        number: 22,
        title: "The Master Builder",
        keywords: ["Manifestation", "Power", "Vision", "Practicality"],
        description: "Life Path 22 is a Master Number. You have the vision of the 11 combined with the practicality of the 4. You have the potential to turn big dreams into reality.",
        strengths: ["Visionary", "Practical", "Powerful", "Disciplined"],
        challenges: ["Overwhelmed", "Controlling", "Rigid", "Fear of failure"]
    },
    33: {
        number: 33,
        title: "The Master Teacher",
        keywords: ["Compassion", "Healing", "Guidance", "Service"],
        description: "Life Path 33 is a Master Number. You are the 'Master Teacher' and have a deep desire to heal and guide others with compassion and love.",
        strengths: ["Compassionate", "Nurturing", "Wise", "Selfless"],
        challenges: ["Overwhelmed", "Martyr complex", "Perfectionist", "Emotional"]
    }
};
